import { render, staticRenderFns } from "./Rule60ResponseInstructions.vue?vue&type=template&id=3fab3ef9&scoped=true"
import script from "./Rule60ResponseInstructions.vue?vue&type=script&lang=ts"
export * from "./Rule60ResponseInstructions.vue?vue&type=script&lang=ts"
import style0 from "./Rule60ResponseInstructions.vue?vue&type=style&index=0&id=3fab3ef9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fab3ef9",
  null
  
)

export default component.exports